<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), {
	size: 16,
});
</script>

<template>
	<!-- eslint-disable max-len -->
	<svg
		:style="{
			width: `${size}px`,
			height: `${size}px`,
		}"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_4482_3628"
			style="mask-type:alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="16"
			height="16"
		>
			<rect
				width="16"
				height="16"
				fill="#D9D9D9"
			/>
		</mask>
		<g mask="url(#mask0_4482_3628)">
			<!-- eslint-disable max-len -->
			<path
				d="M5.08398 4.26634L6.95065 1.84967C7.08398 1.6719 7.24232 1.54134 7.42565 1.45801C7.60898 1.37467 7.80065 1.33301 8.00065 1.33301C8.20065 1.33301 8.39232 1.37467 8.57565 1.45801C8.75898 1.54134 8.91732 1.6719 9.05065 1.84967L10.9173 4.26634L13.7507 5.21634C14.0395 5.30523 14.2673 5.46912 14.434 5.70801C14.6006 5.9469 14.684 6.21079 14.684 6.49967C14.684 6.63301 14.6645 6.76634 14.6257 6.89967C14.5868 7.03301 14.5229 7.16079 14.434 7.28301L12.6006 9.88301L12.6673 12.6163C12.6784 13.0052 12.5507 13.333 12.284 13.5997C12.0173 13.8663 11.7062 13.9997 11.3507 13.9997C11.3284 13.9997 11.2062 13.983 10.984 13.9497L8.00065 13.1163L5.01732 13.9497C4.96176 13.9719 4.90065 13.9858 4.83398 13.9913C4.76732 13.9969 4.70621 13.9997 4.65065 13.9997C4.2951 13.9997 3.98398 13.8663 3.71732 13.5997C3.45065 13.333 3.32287 13.0052 3.33398 12.6163L3.40065 9.86634L1.58398 7.28301C1.4951 7.16079 1.43121 7.03301 1.39232 6.89967C1.35343 6.76634 1.33398 6.63301 1.33398 6.49967C1.33398 6.2219 1.41454 5.96356 1.57565 5.72467C1.73676 5.48579 1.96176 5.31634 2.25065 5.21634L5.08398 4.26634Z"
				fill="currentColor"
			/>
			<!-- eslint-enable max-len -->
		</g>
	</svg>
</template>
